import { render, staticRenderFns } from "./SubTabUpStim.vue?vue&type=template&id=29094082&"
import script from "./SubTabUpStim.vue?vue&type=script&lang=js&"
export * from "./SubTabUpStim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports